<script setup lang="ts"></script>

<template>
  <icon name="lucide:edit" />
</template>

<style scoped></style>
